// extracted by mini-css-extract-plugin
export default {"btn-on-map-group":"BtnOnMapGroup_btn-on-map-group__OTI9q"};